export default "__VITE_ASSET__Dlkv2sF7__"